import { ReactNode } from "react";
import './Layouts.scss'
import { ClassNames } from "../Util/ClassNames";
export function FlexRowOne(props:{children:ReactNode, classNames?:string[]}){
    const classNames:ClassNames = new ClassNames(['flex-row'])
    if(props.classNames){classNames.addClasses(props.classNames)}
    return(
        <div className={classNames.toString()}>
            <div className='flex-column' style={{flex:1}}>{props.children}</div>
        </div>
    ) 
}
export function FlexRowTwo(props:{width?:number, children:ReactNode[], columnOneFlex:number, columnTwoFlex:number, classNames?:string[]}){
    const classNames:ClassNames = new ClassNames(['flex-row', 'flex-row-two'])
    if(props.classNames){classNames.addClasses(props.classNames)}
    const width:string|number = (props.width) ? props.width : '100%'
    return(
        <div style={{width:width}}className={classNames.toString()}>
            <div className='flex-column' style={{flex:props.columnOneFlex}}>{props.children[0]}</div>
            <div className='flex-column' style={{flex:props.columnTwoFlex}}>{props.children[1]}</div>
        </div>
    ) 
}


export function FlexRowThree(props:{children:ReactNode[], width?:number, columnOneFlex:number, columnTwoFlex:number, columnThreeFlex:number, classNames?:string[]}){
    const classNames:ClassNames = new ClassNames(['flex-row', 'flex-row-three'])
    if(props.classNames){classNames.addClasses(props.classNames)}
    return(
        <div className={classNames.toString()} style={{width:props.width}}>
            <div className='flex-column' style={{flex:props.columnOneFlex}}>{props.children[0]}</div>
            <div className='flex-column' style={{flex:props.columnTwoFlex}}>{props.children[1]}</div>
            <div className='flex-column' style={{flex:props.columnThreeFlex}}>{props.children[2]}</div>
        </div>
    ) 
}